function initNewsletter() {
  const containers = document.querySelectorAll('.ml-subscribe-form[id^="mlb2-"]');
  if (!containers.length) return;

  containers.forEach(function(container) {
    const id = container.id.replace('mlb2-', '');

    // Register the MailerLite success callback dynamically for this ID
    window['ml_webform_success_' + id] = function() {
      const successRow = container.querySelector('.row-success');
      const formRow = container.querySelector('.row-form');
      const title = container.closest('.blocks__newsletter__content')?.querySelector('.blocks__newsletter__content__title');
      if (successRow) successRow.style.display = 'block';
      if (formRow) formRow.style.display = 'none';
      if (title) title.style.display = 'none';
    };
  });

  // Load MailerLite webforms script once
  if (!window.mlWebformsLoaded) {
    const script = document.createElement('script');
    script.src = 'https://groot.mailerlite.com/js/w/webforms.min.js?v95037e5bac78f29ed026832ca21a7c7b';
    script.type = 'text/javascript';
    script.onload = function() {
      window.mlWebformsLoaded = true;
    };
    document.body.appendChild(script);
  }
}

initNewsletter();